// extracted by mini-css-extract-plugin
export default {"container":"LoadingTable_container__P8WtO","spinner":"LoadingTable_spinner__jVgJn"};